module.exports = __webpack_public_path__ + "img/regtime_logo.c8ce2245.svg";